import { useState } from "react";
import { Instagram, X } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { PageHero, usePageMeta } from "@/components/site/PageHero";
import { CtaBand } from "@/components/site/CtaBand";
import { Stories } from "@/components/site/Stories";
import { GALLERY } from "@/lib/content";
import { INSTAGRAM_URL } from "@/lib/site";

export default function GalleryPage() {
  usePageMeta("Galeri", "FX Motor Sporları parkurundan, garajından ve turlarından kareler — Çekmeköy / Ömerli.");
  const [active, setActive] = useState(null);
  return (
    <>
      <PageHero eyebrow="Galeri" title="Parkurdan kareler." intro="Çekmeköy Ormanları'ndan, garajımızdan ve turlarımızdan. Daha fazlası Instagram'da." img="/ig/ig24c.jpg" alt="Tepede enduro sürücüsü" crumbs={[{ label: "Galeri" }]} />
      <Stories title="Videolar" />
      <section className="mx-auto max-w-7xl px-5 py-20 md:px-8">
        <div className="columns-2 gap-3 md:columns-3 lg:columns-4 [&>*]:mb-3">
          {GALLERY.map((src, i) => (
            <button key={src} onClick={() => setActive(src)} data-testid={`gallery-item-${i}`} className="group block w-full break-inside-avoid overflow-hidden border border-white/10">
              <img src={src} alt={`FX Motor Sporları galeri ${i + 1}`} loading="lazy" className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </button>
          ))}
        </div>
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="gallery-page-instagram-link" className="mt-10 inline-flex items-center gap-3 border border-white/20 px-6 py-3 font-semibold text-white transition-colors hover:border-white">
          <Instagram className="h-5 w-5" /> Instagram'da daha fazlası: @fxmotorsporlari
        </a>
      </section>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent data-testid="gallery-lightbox" className="max-w-4xl rounded-none border-white/10 bg-black p-2 [&>button]:hidden">
          <DialogTitle className="sr-only">Galeri görseli</DialogTitle>
          {active && <img src={active} alt="FX Motor Sporları galeri görseli" className="max-h-[85vh] w-full object-contain" />}
          <button onClick={() => setActive(null)} data-testid="gallery-lightbox-close" aria-label="Kapat" className="absolute right-3 top-3 bg-brand p-2 text-white"><X className="h-5 w-5" /></button>
        </DialogContent>
      </Dialog>
      <CtaBand />
    </>
  );
}
